import { faCheckCircle, faExclamationCircle, faExclamationTriangle, faTimes } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Icon, notification, Row } from "antd";
import React from "react";
import { ColorConfigs } from "../configurations";
var openNotification = function (noti, type, message, description, postion, duration, width, positionY) {
    if (type === void 0) { type = "primary"; }
    if (postion === void 0) { postion = "0%"; }
    if (duration === void 0) { duration = 3; }
    if (width === void 0) { width = "auto"; }
    if (positionY === void 0) { positionY = "auto"; }
    var icon;
    var color;
    var colorLight;
    var borderWidth;
    var borderColor;
    var background;
    var iconFa = faExclamationCircle;
    if (noti === "success") {
        color = ColorConfigs.green;
        colorLight = ColorConfigs.green1;
        iconFa = faCheckCircle;
    }
    else if (noti === "error") {
        color = ColorConfigs.pink;
        colorLight = ColorConfigs.pink1;
        iconFa = faExclamationTriangle;
    }
    else if (noti === "info") {
        color = ColorConfigs.blue5;
        colorLight = ColorConfigs.blue7;
        iconFa = faExclamationCircle;
    }
    else if (noti === "warning") {
        color = ColorConfigs.yellow;
        colorLight = ColorConfigs.yellow1;
        iconFa = faExclamationTriangle;
    }
    else {
        console.log("You shouldn't get here");
    }
    if (type === "default") {
        background = ColorConfigs.white;
        borderWidth = "0px";
        borderColor = ColorConfigs.gray2;
        icon = React.createElement(FontAwesomeIcon, { icon: iconFa, style: { color: color, backgroundColor: ColorConfigs.white, fontSize: "30px" } });
    }
    else if (type === "primary") {
        background = "linear-gradient(90deg," + color + " 56px, " + colorLight + " 56px)";
        borderWidth = "4px";
        borderColor = color;
        icon = React.createElement(FontAwesomeIcon, { icon: iconFa, style: { color: ColorConfigs.white, backgroundColor: color, fontSize: "30px" } });
    }
    else if (type === "ghost") {
        background = ColorConfigs.gray2;
        borderWidth = "0px";
        borderColor = ColorConfigs.gray2;
        icon = React.createElement(FontAwesomeIcon, { icon: iconFa, style: { color: color, backgroundColor: ColorConfigs.gray2, fontSize: "30px" } });
    }
    else {
        console.log("You shouldn't get here");
    }
    notification.open({
        message: React.createElement("div", { className: "font-size-md padding-sm" },
            React.createElement("b", null, message),
            React.createElement("br", null),
            description),
        placement: "topLeft",
        icon: React.createElement(Row, { type: "flex", style: { height: "100%" }, justify: "center", align: "middle" },
            React.createElement(Col, null, icon)),
        closeIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faTimes }); } }),
        duration: duration,
        className: "custom-notification",
        style: {
            borderStyle: "solid",
            borderColor: borderColor,
            borderWidth: borderWidth,
            borderRadius: "6px",
            width: width,
            padding: "0px 8px",
            background: background,
            left: postion,
            top: positionY,
            wordBreak: 'break-word'
        }
    });
};
export var info = function (message, description, type, width, postion, duration, positionY) {
    openNotification("info", type, message, description, postion, duration, width, positionY);
};
export var error = function (message, description, type, width, postion, duration, positionY) {
    openNotification("error", type, message, description, postion, duration, width, positionY);
};
export var success = function (message, description, type, width, postion, duration, positionY) {
    openNotification("success", type, message, description, postion, duration, width, positionY);
};
export var warning = function (message, description, type, width, postion, duration, positionY) {
    openNotification("warning", type, message, description, postion, duration, width, positionY);
};
//# sourceMappingURL=notification.js.map